import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ContactComponent } from './contact/contact.component';
import { Error404Component } from './error/error-404.component';
import { HomeComponent } from './home/home.component';

const appRoutes: Routes = [
    {path: '', component: HomeComponent},
    {path: 'contact', component: ContactComponent},
    {path: '404', component: Error404Component},
    {path: '**', redirectTo: '404'},
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            appRoutes,
        ),
    ],
    exports: [
        RouterModule,
    ],
    providers: [],
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/app-routing.module.ts